import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
  INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD,
  INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_CATEGORY_PAGE_REQUEST,
  INGREDIENT_CATEGORY_CATEGORIES_REQUEST,
  INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY,
  INGREDIENT_CATEGORY_ON_CLICK_CANCEL,
  INGREDIENT_CATEGORY_ON_CLICK_ROW,
  INGREDIENT_CATEGORY_SUBMIT_FORM,
  INGREDIENT_CATEGORY_DELETE_CATEGORY,
  INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST,
} from 'actions/ingredients/category/constants';
import * as act from 'actions';
import * as actIngCat from 'actions/ingredients/category';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import * as apiIng from 'api/ingredients';
import * as actNotif from 'actions/notifications';
import { initialize, reset } from 'redux-form';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as apiIngCat from 'api/ingredientCategories';
import { delay } from 'redux-saga';
import _ from 'lodash';
import * as clevertapIngredientCategories from 'clevertap/ingredient/categories';
import * as actOutletList from 'actions/outletPages/list';

const getOutlet = state => state.form.search.values.outletIds;

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

export function* pageRequest() {
  yield put(showPageLoadingSpinner(true));
  yield put(act.showProgressBar());
  yield put(actIngCat.setOutlets([]));
  yield put(actIngCat.setCategories([]));
  yield put(actIngCat.setCategoryDetail(null));
  yield put(actIngCat.closeRightColumn());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actIngCat.setOutlets(response.data));

    const resProfile = yield call(apiProfile.getProfile);

    yield put(
      initialize('search', {
        outletIds: [resProfile.data.outlet_id[0]],
      })
    );
    yield put(
      actIngCat.categoriesRequest(
        {
          page: 1,
        },
        []
      )
    );
    clevertapIngredientCategories.ingredientCategoryStart({
      outletIds: [resProfile.data.outlet_id[0]],
    });
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onChangeOutletIds(request) {
  const outlet = yield select(getOutlet);
  const {
    payload: { outletIds },
  } = request;

  clevertapIngredientCategories.ingredientCategoryChangeOutlet({
    currentOutlet: outlet,
    outletIds,
  });
  yield put(actIngCat.closeRightColumn());
  yield put(showPageLoadingSpinner(true));
  yield put(actIngCat.setCategories([]));
  yield put(actIngCat.setCategoryDetail(null));
  yield put(act.showProgressBar());
  yield put(reset('ingCategory'));
  try {
    yield call(apiOutlets.patchLogin, { id: outletIds });
    yield put(
      initialize('search', {
        outletIds,
      })
    );
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(
    actIngCat.categoriesRequest(
      {
        page: 1,
      },
      []
    )
  );
}

export function* onChangeKeyword(request) {
  yield call(delay, 100);
  const {
    payload: { keyword },
  } = request;
  yield put(actIngCat.setCategories([]));
  yield put(
    actIngCat.categoriesRequest(
      {
        page: 1,
        keyword,
      },
      []
    )
  );
}

export function* categoriesRequest(request) {
  const {
    payload: { query, previousCategories },
  } = request;
  if (previousCategories.length === 0) {
    yield put(showPageLoadingSpinner(true));
  }
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiIngCat.getCategories, query);
    const categories = previousCategories.concat(response.data.results);
    yield put(actIngCat.setCategories(categories));
    yield put(actIngCat.setCurrentPage(query.page));
    yield put(actIngCat.setTotalPage(response.data.total_pages));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onClickCreateCategoryFlow() {
  yield put(actIngCat.setCategoryDetail(null));
  yield put(actIngCat.openRightColumn());
  yield put(initialize('ingCategory', {}));
}

export function* onClickCancel() {
  yield put(reset('ingCategory'));
  yield put(actIngCat.setCategoryDetail(null));
  yield put(actIngCat.closeRightColumn());
}

export function* onClickRow(request) {
  const {
    payload: { category },
  } = request;
  // only fetch some data
  yield put(
    initialize('ingCategory', {
      id: category.id,
      name: category.name,
    })
  );
  clevertapIngredientCategories.ingredientCategorySelect({ category });
  yield put(actIngCat.setCategoryDetail(category));
  yield put(actIngCat.openRightColumn());
}

export function* submitForm(request) {
  const {
    payload: { category, createAllOutlet, previousCategories, outletIds },
  } = request;
  const categoryId = category.ingredient_category.id;
  yield put(actIngCat.setIsSubmitting(true));

  try {
    let newCategory = {};
    yield put(act.showProgressBar());
    let newCategories = [];
    if (!categoryId) {
      // create category
      let flag = false;
      if (createAllOutlet) {
        _.forEach(previousCategories, prevCat => {
          if (category.ingredient_category.name === prevCat.name) flag = true;
        });
        const res = yield call(apiIngCat.postCreateAllOutlet, category, {});
        newCategories = res.data;
        const outletId = outletIds[0];
        _.forEach(newCategories, cat => {
          if (cat.outlet_id === outletId) {
            newCategory = cat;
          }
        });
        clevertapIngredientCategories.ingredientCategoryCreate({
          category: category.ingredient_category,
          allOutlet: true,
        });
      } else {
        const res = yield call(
          apiIngCat.postCategory,
          category.ingredient_category,
          {}
        );
        newCategory = res.data;
        clevertapIngredientCategories.ingredientCategoryCreate({
          category: category.ingredient_category,
          allOutlet: false,
        });
      }
      newCategories = flag
        ? [...previousCategories]
        : [newCategory, ...previousCategories];
    } else {
      const res = yield call(apiIngCat.putCategory, categoryId, category, {});
      newCategory = res.data;
      _.forEach(previousCategories, (cat, idx) => {
        if (newCategory.id === cat.id) {
          previousCategories[idx] = newCategory;
        }
      });
      newCategories = [...previousCategories];
    }
    yield put(actIngCat.setCategoryDetail(newCategory));
    yield put(actIngCat.setCategories(newCategories));
    if (categoryId) {
      yield put(
        actNotif.success(
          'Ingredient Category was successfully updated.',
          yield getCloneOutletNotification()
        )
      );
    } else {
      yield put(
        actNotif.success(
          'Ingredient Category successfully created.',
          yield getCloneOutletNotification()
        )
      );
    }
    // re-init with new value
    yield put(
      initialize('ingCategory', {
        id: newCategory.id,
        name: newCategory.name,
      })
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngCat.setIsSubmitting(false));
    yield put(act.hideProgressBar());
  }
}

export function* deleteCategory(request) {
  const {
    payload: { category, categories },
  } = request;
  yield put(act.showProgressBar());
  clevertapIngredientCategories.ingredientCategoryDelete({ category });
  try {
    yield call(apiIngCat.deleteCategory, category.id, {});
    const newCategories = [];
    categories.forEach(cat => {
      if (cat.id !== category.id) {
        newCategories.push(cat);
      }
    });
    yield put(actIngCat.setCategories(newCategories));
    yield put(actIngCat.setCategoryDetail(null));
    yield put(actIngCat.closeRightColumn());
    yield put(actIngCat.hideDeleteModal());
    yield put(actNotif.success('Category was successfully removed.'));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickAssignToIngredientFlow(request) {
  const {
    payload: { category },
  } = request;
  yield put(act.showProgressBar());
  try {
    yield put(actIngCat.assignToIngredientSetCategory(category));
    const resIngredients = yield call(apiIng.getIngredients, {
      page: 1,
      meta_ingredient_category_id: category.id,
    });
    const ingredients = resIngredients.data;
    yield put(
      actIngCat.assignToIngredientFillForm(
        category,
        ingredients.meta.ingredient_ids
      )
    );
    yield put(actIngCat.assignToIngredientSetCurrentPage(1));
    yield put(
      actIngCat.assignToIngredientSetTotalPage(ingredients.meta.total_pages)
    );
    yield put(actIngCat.assignToIngredientSetIngredients(ingredients.results));
    yield put(actIngCat.showAssignToIngredientModal());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelAssignToIngredientFlow() {
  yield put(actIngCat.hideAssignToIngredientModal());
}

export function* submitAssignToIngredientFlow(request) {
  const {
    payload: { data, category },
  } = request;
  try {
    clevertapIngredientCategories.ingredientCategoryAssign({ category, data });
    yield put(act.showProgressBar());
    yield put(actIngCat.hideAssignToIngredientModal());
    yield call(apiIngCat.assignToIngredient, category.id, data);
    yield put(actIngCat.setCategoryDetail(null));
    yield put(actIngCat.closeRightColumn());
    const resCategories = yield call(apiIngCat.getCategories, {
      with_items: true,
      page: 1,
    });
    const categories = resCategories.data.results;
    yield put(actIngCat.setCategories(categories));
    yield put(actIngCat.setTotalPage(resCategories.data.total_pages));
    yield put(actIngCat.setCurrentPage(1));
    yield put(actIngCat.assignToIngredientSetCategory(null));
    yield put(
      actNotif.success(
        'Successfully move selected ingredients.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* fillFormAssignToIngredientFlow(request) {
  const {
    payload: { category, ingredients },
  } = request;
  const form = {
    id: category.id,
    ingredientIds: !ingredients ? [] : ingredients,
  };
  yield put(initialize('assignToIngredient', form));
}

export function* assignToIngredientGetIngredientsRequestFlow(request) {
  const {
    payload: { params, previousIngredients },
  } = request;
  try {
    yield put(act.showProgressBar());
    const resIngredients = yield call(apiIng.getIngredients, params);
    yield put(actIngCat.assignToIngredientSetCurrentPage(params.page));
    yield put(
      actIngCat.assignToIngredientSetTotalPage(
        resIngredients.data.meta.total_pages
      )
    );
    const ingredients = previousIngredients.concat(resIngredients.data.results);
    yield put(actIngCat.assignToIngredientSetIngredients(ingredients));
    yield put(actIngCat.showAssignToIngredientModal());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export default function* saga() {
  yield takeLatest(INGREDIENT_CATEGORY_PAGE_REQUEST, pageRequest);
  yield takeLatest(INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  yield takeLatest(INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD, onChangeKeyword);
  yield takeLatest(INGREDIENT_CATEGORY_CATEGORIES_REQUEST, categoriesRequest);
  yield takeLatest(
    INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY,
    onClickCreateCategoryFlow
  );
  yield takeLatest(INGREDIENT_CATEGORY_ON_CLICK_CANCEL, onClickCancel);
  yield takeLatest(INGREDIENT_CATEGORY_ON_CLICK_ROW, onClickRow);
  yield takeLatest(INGREDIENT_CATEGORY_SUBMIT_FORM, submitForm);
  yield takeLatest(INGREDIENT_CATEGORY_DELETE_CATEGORY, deleteCategory);
  yield takeLatest(
    INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT,
    onClickAssignToIngredientFlow
  );
  yield takeLatest(
    INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT,
    cancelAssignToIngredientFlow
  );
  yield takeLatest(
    INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT,
    submitAssignToIngredientFlow
  );
  yield takeLatest(
    INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM,
    fillFormAssignToIngredientFlow
  );
  yield takeLatest(
    INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST,
    assignToIngredientGetIngredientsRequestFlow
  );
}
